import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translation.json";
import ru from "./locales/ru/translation.json";
import kz from "./locales/kz/translation.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ru: { translation: ru },
    kz: { translation: kz }
  },
  lng: "ru", // язык по умолчанию
  fallbackLng: "ru", // если нет перевода — показываем английский
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
